import './Card.css';

import React from 'react';
import classnames from 'classnames';

export default class Card extends React.Component {
  handleClick() {
    if (!this.props.flipped) {
      this.props.checkMatch(this.props.value, this.props.id);
    } else {
      this.props.flipBack(this.props.id);
    }
  }

  onAnimationEnd(event) {
    this.props.onAnimationEndCallback(event);
  }

  render() {
    const classes = classnames(
      'Card',
      'Card--' + this.props.type,
      {'fold' : this.props.fold},
      {'flip' : this.props.type === 'matching' || this.props.flipped},
      {'flipAnimate': this.props.flipAnimate},
      {'flipAnimateReverse': this.props.flipAnimateReverse},
      this.props.value,
      this.props.className
    )

    if (this.props.type === 'playing') {
      // Use a button if the card is interactive
      const cardValue = this.props.flipped ? this.props.value : 'Click the card to reveal the value';

      return (
        <div className={classes}
          onAnimationEnd={this.onAnimationEnd.bind(this)}
          onClick={this.handleClick.bind(this)}
        >
          <span className="sr-only">{cardValue}</span>
        </div>
      )
    } else {
      // Use a div if the card is not interactive
      return (
        <div className={classes}></div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/du/Card/Card.js